import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import "../../css/deprecation-banner.scss";

const NEW_PLATFORM_URL = "https://membros.paradigma.education";
const STAY_KEY = "paradigma:stay-on-legacy";
const COUNTDOWN_SECONDS = 7;

/**
 * Escape hatch: app.paradigma.education/?stay=1 keeps the legacy app browsable
 * in that browser from then on, so the old data stays reachable without
 * reverting this deploy.
 */
const isStaying = () => {
  const fromQuery = () => {
    try {
      return new URLSearchParams(window.location.search).get("stay") === "1";
    } catch (error) {
      return false;
    }
  };

  try {
    if (fromQuery()) {
      window.localStorage.setItem(STAY_KEY, "1");
      return true;
    }
    return window.localStorage.getItem(STAY_KEY) === "1";
  } catch (error) {
    // localStorage bloqueado (Safari privado): vale só o parâmetro da URL.
    return fromQuery();
  }
};

const DeprecationBanner = () => {
  const [staying] = useState(isStaying);
  const [seconds, setSeconds] = useState(COUNTDOWN_SECONDS);

  // Escurece e trava a plataforma antiga enquanto o aviso está na tela. O
  // aviso vive num portal fora de .App justamente para não herdar a opacidade.
  useEffect(() => {
    if (staying) return undefined;

    document.body.classList.add("deprecation-lock");
    const tick = window.setInterval(() => {
      setSeconds((current) => (current > 0 ? current - 1 : 0));
    }, 1000);

    return () => {
      window.clearInterval(tick);
      document.body.classList.remove("deprecation-lock");
    };
  }, [staying]);

  useEffect(() => {
    if (!staying && seconds === 0) window.location.assign(NEW_PLATFORM_URL);
  }, [staying, seconds]);

  if (staying) return null;

  return createPortal(
    <div className="deprecation-overlay" role="alertdialog" aria-live="assertive">
      <div className="deprecation-banner">
        <p className="deprecation-banner__countdown">{seconds}</p>

        <p className="deprecation-banner__text">
          Migramos para uma nova plataforma. Você será redirecionado. Se é
          assinante Pro, seu plano segue válido normalmente.
        </p>

        <a className="deprecation-banner__cta" href={NEW_PLATFORM_URL}>
          ME LEVA LÁ
        </a>
      </div>
    </div>,
    document.body
  );
};

export default DeprecationBanner;
